module.exports = __webpack_public_path__ + "static/media/4.851d930f.jpg";